import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HaylieService } from '../../core/services/haylie.service'
import { ePicture } from '../../core/services/entities'

import { BtnComponent } from '../../shared/btn.component/btn.component';
import { CardComponent } from '../../shared/card.component/card.component';
//import { BlockComponent } from '../../shared/block.component/block.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckDouble, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-home',
  imports: [CommonModule, BtnComponent, CardComponent, FontAwesomeModule ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  faWhatsapp=faWhatsapp;
  faCheck=faCheckDouble;
  faMapMarkerAlt=faMapMarkerAlt;

  model_pics: ePicture[] = [];

  constructor(private haylie: HaylieService) { 
    
  }

  ngOnInit(): void {
    //this.get_gallery();
  }
  ngAfterViewInit(): void {
    this.get_gallery();
  }
  get_gallery(): void {
    this.haylie.get_gallery().then(this.load_gallery);
  }
  private load_gallery = (p_response: any) =>  {
    var l_response = JSON.parse(p_response);
    this.model_pics = l_response.pictures;
    return this.model_pics;
   
  }
  navigate(p_route:string): void {
  }

}

